<template>
  <div
    class="edit-div"
    :contenteditable="canEdit"
    tabindex="0"
    @focus="isLocked = true"
    @blur="isLocked = false"
    @input="changeText"
    v-html="innerText"
  ></div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerText: this.value,
      isLocked: false
    };
  },
  watch: {
    value() {
      if (!this.isLocked || !this.innerText) {
        this.innerText = this.value;
      }
    }
  },
  methods: {
    changeText() {
      this.$emit("input", this.$el.innerText);
    }
  }
};
</script>
